import React from 'react';

import CommonImage from '@components/CommonImage';

const BottomActionWrapper = ({ children, onClose }) => {
	return (
		<div className="design-count-section bg-white order-task-popup d-flex justify-content-center align-items-center">
			{children}
			<CommonImage
				src="/icons/close.svg"
				alt="down"
				className="ml-1 close-icon cursor-pointer"
				onClick={onClose}
			/>
		</div>
	);
};

export default BottomActionWrapper;
